import React from 'react';
import { Box, TextV2 } from '@withjoy/joykit';

type SummaryItemProps = {
  label: string;
  value: string;
};

export const SummaryItem = ({ label, value }: SummaryItemProps) => {
  return (
    <Box>
      <TextV2
        typographyVariant="body1"
        fontWeight="semibold"
        color="mono12"
        marginBottom="4px"
      >
        {label}
      </TextV2>
      <TextV2
        typographyVariant="body1"
        color="mono11"
        paddingLeft={4}
      >
        {value}
      </TextV2>
    </Box>
  );
};
